import { Component, Inject, Vue } from 'vue-property-decorator';
import AccountService from "@/components/account/account.service";
// @ts-ignore
import md5 from 'crypto-js/md5';
import { required, email } from 'vuelidate/lib/validators';
import * as service from "@/methods/service";

const validations = {
	email: { required, email },
}

@Component({
	components: {},
	validations
})
export default class AuthorizationComponent extends Vue {

	@Inject('accountService') private accountService!: () => AccountService;


	public email: string = '';
	public emailSuccessfullySent = false;
	public error = '';

	public async submit() {
		this.error = '';
		this.emailSuccessfullySent = false;
		try {
			this.$store.commit('setOverlay', true)
			await service.setPasswordResetKey(this.email)
			this.$store.commit('setOverlay', false)
			this.emailSuccessfullySent = true;
		} catch (e) {
			this.$store.commit('setOverlay', false)
			this.error = e.message;
		}

	}
}
